<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CNDKaU/tc-custom/cover.jpg?1684515199437?1702530412190" alt="This image is the cover for the book Lost Restaurants of Grand Rapids, American Palate"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lost Restaurants of Grand Rapids, American Palate
      </h1>
      <p class="bookDescription body article font2">
        <p>Grand Rapids restaurants have served up meals and memories since the city's earliest days. At Bentham's, one of the first downtown restaurants, customers without money to eat could trade an animal pelt for supper. John Sebaitis trained his German shepherd, Spooky, to serve beer to the patrons at his tavern. And a seventeen-year-old Gerald R. Ford worked part time as a server and dish washer at Bill's Place. Join Norma Lewis as she explores the history of Grand Rapids' most beloved eateries and the stories behind them.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Norma Lewis
      </h2>
      
      <p class="authorDescription body article">Norma Lewis has lived in or near the Grand Rapids area for over twenty-five years. She is a member of the Grand Rapids Historical Society, the Grand Rapids Women's History Council and the Tri-Cities Historical Museum in Grand Haven. Lost Restaurants of Grand Rapids is Norma's ninth book. She has authored five books with Arcadia Publishing, three of them with her late husband Jay de Vries, and has also published a children's book on the Transcontinental Railroad.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?28f1c86c